import HomeIcon from '@public/icon/menu/home.svg';
import DepositIcon from '@public/icon/menu/deposit.svg';
import MyBetsIcon from '@public/icon/menu/myBets.svg';
import TransactionHistory from '@public/icon/menu/transactionHistory.svg';
import RankingIcon from '@public/icon/menu/ranking.svg';
import LuckyDrawIcon from '@public/icon/menu/lucky-draw.svg';
import TournamentIcon from '@public/icon/menu/tournament.svg';

const menu = [
  {
    path: '/home',
    label: 'home',
    icon: <HomeIcon />,
  },
  {
    path: '/game-recharge',
    label: 'purchase',
    icon: <DepositIcon />,
    needLogin: true,
    needFirstPartyGateway: true,
  },
  {
    path: '/game-review',
    label: 'history',
    icon: <MyBetsIcon />,
    needLogin: true,
  },
  {
    path: '/history',
    label: 'transaction_history',
    icon: <TransactionHistory />,
    needLogin: true,
  },
  {
    path: '/ranking',
    label: 'ranking',
    icon: <RankingIcon />,
    needLogin: true,
  },
  {
    path: '/fortune-wheel',
    label: 'lucky_draw',
    icon: <LuckyDrawIcon />,
    needLogin: true,
  },
  {
    path: '/tournament',
    label: 'tournament',
    icon: <TournamentIcon />,
    needLogin: true,
  },
  // {
  //   path: '/game-recharge?type=lucky-draw',
  //   label: 'lucky_draw',
  //   icon: <LuckyDrawIcon />,
  //   needLogin: true,
  // },
  // {
  //   path: '/login',
  //   label: 'cms_login',
  // },
  // {
  //   path: '/login/register',
  //   label: 'register',
  // },
  // {
  //   path: '/login/login-player',
  //   label: 'player_login',
  // },
];

export default menu;
